import { render, staticRenderFns } from "./radar-chart.component.vue?vue&type=template&id=d338d08a"
import script from "./radar-chart.component.vue?vue&type=script&lang=ts"
export * from "./radar-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./radar-chart.component.vue?vue&type=style&index=0&id=d338d08a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports